import { OutlinedInput, InputAdornment } from '@mui/material'
import SearchOutlinedIcon from '@mui/icons-material/SearchOutlined'
import { useState } from 'react'
import { useFormikContext, FormikValues } from 'formik'
import { useTranslation } from '@theme/base/contexts/TranslationContext'

interface SearchFilterFormikProps {
  paramName?: string | undefined
  placeholderTranslationKey?: string | undefined
  size?: 'small' | 'medium'
}

const SearchFilterFormik = ({ paramName, placeholderTranslationKey, size = 'small' }: SearchFilterFormikProps) => {
  const filterName = paramName ?? 'search'

  const { getTranslation } = useTranslation()
  const { setFieldValue, values, handleSubmit } = useFormikContext<FormikValues>()
  const [searchInput, setSearchInput] = useState<string>(values[filterName] ?? '')

  const handleChangeSearch = (value: string) => {
    setSearchInput(value)
    
    if (value?.length >= 2) {
      setFieldValue(filterName, value)
      
    } else {
      setFieldValue(filterName, '')
    }
    setFieldValue('page', 1)

    handleSubmit()
  }

  return (
    <OutlinedInput
      id={`${filterName}-input`}
      name={filterName}
      type="search"
      fullWidth
      size={size}
      placeholder={placeholderTranslationKey ? getTranslation(placeholderTranslationKey) : getTranslation('common.filters.search')}
      value={searchInput}
      onChange={(e) => handleChangeSearch(e.target.value)}
      endAdornment={
        <InputAdornment position="end">
          <SearchOutlinedIcon />
        </InputAdornment>
      }
    />
  )
}

export default SearchFilterFormik
